import { View, Text } from "react-native";
import Marquee from "react-fast-marquee";
import { spacing_l, spacing_s } from "../../StyleHelpers";

interface Props {
	title?: any;
	width?: any;
	isNarrow?: boolean;
}
const MarqueeText = (props: Props) => {
	return (
		<View
			style={{
				overflow: "hidden",
				width: props?.width ?? 300,
				backgroundColor: "transparent",
				marginBottom: props.isNarrow ? spacing_s : spacing_l,
			}}
		>
			<Marquee loop={0} speed={50} direction={"left"}>
				<Text
					style={{
						color: "white",
						fontSize: props.isNarrow ? 21 : 25,
						fontWeight: "500",
						paddingRight: 100,
					}}
					numberOfLines={1}
				>
					{props.title}
				</Text>
			</Marquee>
		</View>
	);
};

export default MarqueeText;
